// extracted by mini-css-extract-plugin
module.exports = {"fold":"Accordian_fold__3J-Sx","title":"Accordian_title__2_12t","last":"Accordian_last__yYUdI","body":"Accordian_body__28DB3"};